import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 600px;
  padding: 16px;
  box-sizing: border-box;
  background: var(--yrm-surface);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
`;

export const HeaderInfo = styled.div`
  margin-bottom: 20px;
  padding: 16px;
  background: var(--yrm-surface-2);
  border-radius: 8px;
  border-left: 4px solid var(--yrm-primary);
  
  ul {
    margin: 0;
    padding-left: 20px;
    
    li {
      font-size: 14px;
      color: var(--yrm-text-2);
      margin: 4px 0;
      line-height: 1.5;
    }
  }
`;

export const TimelineDate = styled.span`
  background: linear-gradient(135deg, #13143A, #2d3748);
  color: white;
  border-radius: 12px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  display: inline-block;
  box-shadow: 0 2px 4px rgba(19, 20, 58, 0.2);
  margin-bottom: 8px;
`;

export const MovPanel = styled.div`
  .ant-collapse {
    background: transparent;
    border: none;
    border-radius: 8px;
  }
  
  .ant-collapse-item {
    background: var(--yrm-surface);
    border: 1px solid var(--yrm-border);
    border-radius: 8px !important;
    margin-bottom: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    overflow: hidden;
  }
  
  .ant-collapse-item > .ant-collapse-header {
    padding: 16px 20px;
    background: var(--yrm-surface-2);
    border-radius: 8px 8px 0 0;
    font-weight: 600;
    color: var(--yrm-text-2);
    border-bottom: 1px solid var(--yrm-border);
  }
  
  .ant-collapse-content > .ant-collapse-content-box {
    padding: 16px 20px;
  }
  
  .ant-timeline {
    margin-top: 8px;
  }
  
  .ant-timeline-item {
    padding-bottom: 20px;
  }
  
  .ant-timeline-item-content {
    margin-left: 24px;
    padding: 12px 16px;
    background: var(--yrm-surface-2);
    border-radius: 8px;
    border-left: 3px solid var(--yrm-primary);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }
  
  .ant-timeline-item-head {
    background: var(--yrm-primary);
    border-color: var(--yrm-primary);
    width: 14px;
    height: 14px;
  }
`;
